import { FC } from 'react'
import { Container, ContainerLarge } from '../../container'
import { TimelineVideo } from '../video'
import {
  TimelineTitle,
  TimelineTitleMask,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
  TimelineAnchor,
} from '../styled'
import { texts } from '../../locale'
type Props = {
  scrollUp: boolean
}
export const Chapter_6: FC<Props> = ({ scrollUp }) => {
  return (
    <>
      <TimelineTitle>
        <TimelineAnchor id="chapter-6" $scrollUp={scrollUp} />
        <TimelineTitleMask />
        <img
          src={
            'https://gdb.rferl.org/0D094FD6-358A-46FF-953E-348F244669DB_w1920_r4.jpg'
          }
        />
        <h2>
          <span>6</span>
          Осінній наступ України
          <strong>{texts.menu_12}</strong>
        </h2>
      </TimelineTitle>

      <ContainerLarge>
        <TimelineIntro>
          Україна починає стрімкий наступ на Харківщині, який згодом зачепив і
          Донеччину. Ключовим містом, яке звільнили у цей період, був Ізюм: на
          той момент він був великим логістичним вузлом для окупаційних військ,
          які використовували його для подальших атак на Донеччину – зокрема, на
          Слов’янськ. Велика осіння наступальна операція ЗСУ дозволила вивести
          це та інші міста регіону з-під постійних артилерійських обстрілів та
          загрози захоплення. Загалом за 6 днів вересня 2022-го Сили оборони
          України звільнили близько 300 населених пунктів у Харківській та
          Донецькій областях. Після місячної перерви українські війська
          повторили свій успіх також і на півдні, звільнивши, зокрема, єдиний
          захоплений РФ під час великого вторгнення обласний центр: Херсон.
        </TimelineIntro>

        <TimelineContent>
          <TimelineSubtitle>8 вересня</TimelineSubtitle>
          <p>
            Звільнення Балаклії Харківської області поклало початок наступальній
            кампанії України 2022 року.
          </p>

          <TimelineSubtitle>10 вересня</TimelineSubtitle>
          <p>
            ЗСУ заходять в Ізюм та Куп’янськ Харківської області. Ось як це
            виглядало:
          </p>
          <TimelineVideo id={'inTbrdfbHNo'} />

          <TimelineSubtitle>12 вересня</TimelineSubtitle>
          <p>
            Українська армія звільняє Святогірськ на Донеччині. Це місто стоїть
            переважно на лівому березі річки Сіверський Донець: цей берег був
            окупований, тоді як правий залишався під контролем України.
            Військові заходили у Святогірськ{' '}
            <a href="https://www.radiosvoboda.org/a/zvilnennia-sviatogirska/32031453.html">
              на човнах
            </a>
            .
          </p>

          <TimelineSubtitle>13 вересня</TimelineSubtitle>
          <p>
            Звільнено Вовчанськ Харківської області на кордоні з Росією. По
            всьому шляху українських військових їх зустрічали жителі звільнених
            населених пунктів.
          </p>
          <TimelineVideo id={'ivSS5Wp73jk'} />

          <TimelineSubtitle>1 жовтня</TimelineSubtitle>
          <p>
            Звільнено Лиман на Донеччині. Відтак сформувалась нова конфігурація
            фронту по лінії Діброва-Кислівка, або ж східніше від русла річки
            Оскіл. Осінній наступ на Харківщині та Донеччині відбувався
            настільки стрімко, що чимало пошкодженої техніки і боєкомплекту
            російські військові не встигли забрати, й вони стали трофеями ЗСУ.
          </p>

          <TimelineImage>
            <img
              src={
                'https://gdb.rferl.org/7F575DC6-D72F-4D1E-870E-A7359D276E0C_w1000.jpg'
              }
            />
            <span>
              Українські військові вантажать на транспортер трофейний російський
              танк
            </span>
          </TimelineImage>

          <TimelineSubtitle>24 жовтня</TimelineSubtitle>
          <p>
            До переліку відвойованих Україною додалися села Луганщини:
            Кармазинівка, М’ясожарівка і Невське, а трохи раніше – ще 6
            маленьких сіл. Проте, усі ці населені пункти є настільки
            зруйнованими, що правильніше буде назвати їх позиціями. По них фронт
            проходить і донині.
          </p>

          <TimelineSubtitle>11 листопада</TimelineSubtitle>
          <p>
            Українська армія звільнила обласний центр Херсон та населені пункти
            правого берега Дніпра. Як і щоразу після того, як російська армія
            відходила з українських територій, у містах і селах Херсонської
            області виявляли місця незаконного утримання людей, а цивільні
            розповідали про численні випадки тортур та убивств. Херсон російська
            армія після відступу почала обстрілювати з окупованого лівого берега
            Дніпра. Понині у місті часто гинуть люди через хаотичні «прильоти»
            артилерії біля зупинок, площ, магазинів.
          </p>
          <TimelineVideo id={'W-q1M3ujX68'} />

          <TimelineSubtitle>листопад</TimelineSubtitle>
          <p>
            У цьому періоді варто згадати ще одну важливу битву – хоча вона була
            не наступальною, а оборонною. Під селом Павлівка, що його російські
            війська намагалися пройти, аби захопити Вугледар (місто на півдні
            Донецької області) українські військові знищили «кістяк»{' '}
            <a href="https://www.radiosvoboda.org/a/pavlivka-vuhledar-zsu-rosiya-morpikhy/32124554.html">
              155-ї бригади Тихоокеанського флоту Росії
            </a>
            . На початку листопада у штурмі, за даними російських військових
            оглядачів, загинули близько 300 військових. Вугледар станом на лютий
            2024 року так і залишається під контролем українських військ.
          </p>
        </TimelineContent>
      </ContainerLarge>
    </>
  )
}
